module.exports = __webpack_public_path__ + "img/bumbleme.81be9c52.jpg";